import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

import { ExternalIcon, MenuIcon } from "./icons";

interface MenuItemProps extends React.ComponentProps<"a"> {
  icon: React.ReactNode;
  isExternal?: boolean;
}

export function MenuItem({
  children,
  className,
  icon,
  isExternal = false,
  ...props
}: MenuItemProps) {
  return (
    <a
      className={cn(
        "flex h-11 items-center gap-2.5 rounded-[10px] px-5 transition-colors hover:bg-white/10"
      )}
      rel={isExternal ? "noopener noreferrer" : undefined}
      target={isExternal ? "_blank" : undefined}
      {...props}
    >
      {icon}
      <span className="text-14 text-pale-lavender">{children}</span>
      {isExternal && <ExternalIcon />}
    </a>
  );
}

export interface MenuProps {
  children: React.ReactNode;
  className?: string;
  label: string;
}

export default function Menu({ children, className, label }: MenuProps) {
  return (
    <Popover>
      <PopoverTrigger
        className={cn(
          "group flex h-[36px] items-center rounded-[5px] pr-2 pl-3 text-14 text-white/80 transition-colors hover:bg-white/10 data-[state=open]:bg-white/10",
          className
        )}
      >
        {label}
        <MenuIcon className="ml-1 size-4 transition-transform group-data-[state=open]:rotate-180" />
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="flex w-auto flex-col gap-2 rounded-[20px] border-0 bg-[url(/images/main-bg.jpg)] bg-cover bg-top bg-no-repeat p-2.5 pb-5 shadow-none"
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
